<template>
  <div>
    <b-button
      v-b-modal.sample-modal
      title="print sample"
      variant="outline-secondary"
    >
      <i class="fa fa-print"></i>
    </b-button>
    <b-modal
      id="sample-modal"
      title="Create Knowledge Check"
      hide-footer
    >
      <b-form-group
        id="number-of-questions1"
        label="Number of Questions"
        label-for="number-of-questions"
      >
        <b-form-input
          id="number-of-questions"
          v-model="number"
          type="number"
          placeholder="number of questions"
          required
        ></b-form-input>
      </b-form-group>
      <div class="text-center">
        <b-button
          title="Create"
          variant="primary"
          @click="view"
        >
          Create
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props:{
    title: { type: String, default: 'Knowledge Check' },
    id: { type: String, required: true }
  },
  data(){
    return{
      number:10
    }
  },
  methods:{
    view(){
      this.$router.push({name: 'admin-knowledgecheck-print', params: {id: this.id, number: this.number}})
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/print/select-questions.vue